var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ErrorType } from "../types/ErrorType";
import { normalizeAuthors } from "./authorityAuthorUtils";
export var PUBLICATION_FORMS = [
    "PRINT",
    "EBOOK",
    "DATA_CARRIER",
    "AUDIOBOOK",
];
var isBlank = function (value) { return !value || !value.trim(); };
/**
 * Normalizes a work specification before it is sent to the backend:
 * an empty publicationForm select value must not be submitted, and the empty author / "Jiný
 * formát" rows the form starts with are dropped (an author picked from the NK authorities keeps its link) — the backend would store them as `{}` and the
 * edit form would then report hidden "Required" errors for them (Tools 75665).
 */
export var normalizeWorkSpecification = function (workSpecification) { return (__assign(__assign(__assign(__assign({}, workSpecification), { publicationForm: workSpecification.publicationForm || undefined }), (workSpecification.authors && {
    // keeps the NK authority link (personId + ID AUT) of a picked author (DB-804)
    authors: normalizeAuthors(workSpecification.authors),
})), (workSpecification.otherFormats && {
    otherFormats: workSpecification.otherFormats.filter(function (row) { return !isBlank(row.format); }),
}))); };
/** The refining format values stored for each publication form. */
export var formatsOfPublicationForm = function (workSpecification, publicationForm) {
    var _a, _b, _c, _d, _e;
    if (!workSpecification)
        return [];
    switch (publicationForm) {
        case "PRINT":
            return (_b = (_a = workSpecification.publicationType) === null || _a === void 0 ? void 0 : _a.printedPublications) !== null && _b !== void 0 ? _b : [];
        case "EBOOK":
            return (_c = workSpecification.eBookFormats) !== null && _c !== void 0 ? _c : [];
        case "DATA_CARRIER":
            return (_d = workSpecification.dataCarrierVersions) !== null && _d !== void 0 ? _d : [];
        case "AUDIOBOOK":
            return (_e = workSpecification.audioBookFormats) !== null && _e !== void 0 ? _e : [];
        default:
            return [];
    }
};
/**
 * Number of product formats (= products the agency creates) requested by a work specification.
 * The free-text "Jiný formát" is informative only and is not counted.
 */
export var countProductFormats = function (workSpecification) {
    return PUBLICATION_FORMS.reduce(function (count, form) {
        return count + formatsOfPublicationForm(workSpecification, form).length;
    }, 0);
};
/**
 * True for a request stored before RECEK-74182 that asks for more than one product format — the
 * form can no longer produce such data, but it must still be displayed (and kept when untouched).
 */
export var hasMultipleProductFormats = function (workSpecification) { return countProductFormats(workSpecification) > 1; };
/**
 * The publication form to show in the select: the stored one when it has a refining value (or when no
 * form has any value), otherwise the first form that actually carries a format — e.g. a stored PRINT
 * without a binding but with a CD-ROM is shown as a data carrier.
 */
export var derivePublicationForm = function (workSpecification) {
    var _a, _b;
    var stored = workSpecification === null || workSpecification === void 0 ? void 0 : workSpecification.publicationForm;
    var storedForm = stored && PUBLICATION_FORMS.includes(stored)
        ? stored
        : undefined;
    if (storedForm &&
        formatsOfPublicationForm(workSpecification, storedForm).length > 0) {
        return storedForm;
    }
    return ((_b = (_a = PUBLICATION_FORMS.find(function (form) { return formatsOfPublicationForm(workSpecification, form).length > 0; })) !== null && _a !== void 0 ? _a : storedForm) !== null && _b !== void 0 ? _b : "");
};
/**
 * Normalizes a work specification loaded from the backend into complete form values. The backend
 * omits empty values (non_empty JSON), so a stored author or "Jiný formát" row may come back as
 * `{}` and lists may be missing altogether; every such value becomes "" / [] (Tools 75665).
 *
 * @param workSpecification the stored work specification, if any
 * @return the work specification with every form field present
 */
export var normalizeLoadedWorkSpecification = function (workSpecification) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var ws = workSpecification !== null && workSpecification !== void 0 ? workSpecification : {};
    return __assign(__assign({}, ws), { title: (_a = ws.title) !== null && _a !== void 0 ? _a : "", subtitle: (_b = ws.subtitle) !== null && _b !== void 0 ? _b : "", volumeNumber: (_c = ws.volumeNumber) !== null && _c !== void 0 ? _c : "", partTitle: (_d = ws.partTitle) !== null && _d !== void 0 ? _d : "", authors: ((_e = ws.authors) !== null && _e !== void 0 ? _e : []).map(function (author) {
            var _a, _b;
            return (__assign(__assign({}, author), { firstName: (_a = author === null || author === void 0 ? void 0 : author.firstName) !== null && _a !== void 0 ? _a : "", lastName: (_b = author === null || author === void 0 ? void 0 : author.lastName) !== null && _b !== void 0 ? _b : "" }));
        }), publicationDate: (_f = ws.publicationDate) !== null && _f !== void 0 ? _f : "", editionNumber: (_g = ws.editionNumber) !== null && _g !== void 0 ? _g : "", coEditionWith: (_h = ws.coEditionWith) !== null && _h !== void 0 ? _h : "", 
        // older requests may lack the form of a data carrier / audiobook (RECEK-74182)
        publicationForm: derivePublicationForm(ws), publicationType: {
            printedPublications: (_k = (_j = ws.publicationType) === null || _j === void 0 ? void 0 : _j.printedPublications) !== null && _k !== void 0 ? _k : [],
        }, eBookFormats: (_l = ws.eBookFormats) !== null && _l !== void 0 ? _l : [], otherFormats: ((_m = ws.otherFormats) !== null && _m !== void 0 ? _m : []).map(function (row) {
            var _a;
            return (__assign(__assign({}, row), { format: (_a = row === null || row === void 0 ? void 0 : row.format) !== null && _a !== void 0 ? _a : "" }));
        }), dataCarrierVersions: (_o = ws.dataCarrierVersions) !== null && _o !== void 0 ? _o : [], audioBookFormats: (_p = ws.audioBookFormats) !== null && _p !== void 0 ? _p : [] });
};
/**
 * The format fields after choosing a publication form: the chosen form keeps at most its first
 * refining value, the formats of every other form are cleared — so the payload always carries
 * exactly one format (one product in the agency).
 */
export var formatFieldsForPublicationForm = function (workSpecification, publicationForm) {
    var _a;
    var keep = function (form) {
        return publicationForm === form
            ? formatsOfPublicationForm(workSpecification, form).slice(0, 1)
            : [];
    };
    return {
        publicationForm: publicationForm,
        publicationType: {
            printedPublications: keep("PRINT"),
        },
        eBookFormats: keep("EBOOK"),
        // the free-text "Jiný formát" rows belong to an e-book only
        otherFormats: publicationForm === "EBOOK"
            ? ((_a = workSpecification === null || workSpecification === void 0 ? void 0 : workSpecification.otherFormats) !== null && _a !== void 0 ? _a : []).map(function (row) {
                var _a;
                return ({
                    format: (_a = row.format) !== null && _a !== void 0 ? _a : "",
                });
            })
            : [],
        dataCarrierVersions: keep("DATA_CARRIER"),
        audioBookFormats: keep("AUDIOBOOK"),
    };
};
/**
 * The format fields after choosing a refining value of a publication form: the form carries only
 * that value (or nothing when the select is reset), every other form is cleared.
 */
export var formatFieldsForSelection = function (workSpecification, publicationForm, value) {
    var selected = value ? [value] : [];
    var sources = {
        PRINT: {
            publicationType: {
                printedPublications: selected,
            },
        },
        EBOOK: { eBookFormats: selected },
        DATA_CARRIER: {
            dataCarrierVersions: selected,
        },
        AUDIOBOOK: {
            audioBookFormats: selected,
        },
    };
    return formatFieldsForPublicationForm(__assign(__assign({}, sources[publicationForm]), { otherFormats: workSpecification === null || workSpecification === void 0 ? void 0 : workSpecification.otherFormats }), publicationForm);
};
/**
 * Whether a failed save was rejected by mod-br-publishers because the work specification asks
 * for more than one product format.
 *
 * @param error the error thrown by the ky client (an HTTPError with a response body)
 */
export var isMultipleWorkSpecFormatsError = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var response, body, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                response = error === null || error === void 0 ? void 0 : error.response;
                if (!response || typeof response.clone !== "function")
                    return [2 /*return*/, false];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, response.clone().json()];
            case 2:
                body = _b.sent();
                return [2 /*return*/, (Array.isArray(body === null || body === void 0 ? void 0 : body.errors) &&
                        body.errors.some(function (item) {
                            return (item === null || item === void 0 ? void 0 : item.type) === ErrorType.MULTIPLE_WORK_SPECIFICATION_FORMATS;
                        }))];
            case 3:
                _a = _b.sent();
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
